<div class="cm-landing-fixed-width cm-hero-section">
	<div class="cm-hero-section__left">
		<h1>
			Your Hub for Questions, Ideas, and Experience
		</h1>
		<p>
			Join the CropManage community
		</p>
	</div>
	<div class="cm-hero-section__right">
		<img src="../../../../assets/images/photos/Community.png" width="659" height="366"/>
	</div>
</div>

<div class="cm-landing-fixed-width cm-cta">
	<h2>Connect and Share in the CropManage Community</h2>
	<ul>
		<li>
			<strong>Connect</strong> with other CropManage users
		</li>
		<li>
			<strong>Share</strong> feedback and suggestions
		</li>
		<li>
			<strong>Ask</strong> questions about CropManage
		</li>
	</ul>
	<p>
		<strong>New to Discord?</strong> You'll be guided through creating
		an account when you click the link, or you can read this
		<a href="https://support.discord.com/hc/en-us/articles/360045138571-Beginner-s-Guide-to-Discord" target="_blank">
			quick start quide.</a>
	</p>
	<button (click)="openDiscordLink()" class="cm-button--get-notified">
		Join Us On Discord
	</button>
</div>